import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";

import { FullPageSpinner } from "@/components/Spinner";
import { useGame } from "@/routes/game/queries";

export default function GameLayout() {
    const { gameId } = useParams<{ gameId: string }>();

    const { game, loading, error, refetch } = useGame(gameId);

    useEffect(() => {
        if (!loading && !error && !game) {
            const timeout = setTimeout(() => {
                refetch();
            }, 1000);
            return () => clearTimeout(timeout);
        }
    }, [loading, error, game, refetch]);

    if (!gameId) {
        return null;
    }

    if (error) {
        return <p>Error: {error.message}</p>;
    }

    if (loading || !game) {
        return <FullPageSpinner />;
    }

    return <Outlet context={{ game }} />;
}
